// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover.my-popover{background-color:#fff9e3!important;border-radius:1vw!important;border:.1vw solid #e8c596!important}", ""]);
// Exports
module.exports = exports;
